import numeral from 'numeral';
import { lowerCase, get, forEach, size, replace } from 'lodash';
import { getPickingQuantityByUni } from '../../utils/misc';

const formatProductQuantity = (quantity, unit) => {
    if (lowerCase(unit) === 'kg') return `${(parseFloat(quantity).toFixed(3)).replace('.', ',')} kg`;
    return `${quantity} uni`;
};

const formatPrice = (price) => {
    const clearPrice = (`${price}`).replace(',', '').replace('$', '').replace('.', '');
    const priceFormated = numeral(clearPrice).format('0,0');
    return `$${(priceFormated).replace(/,/g, '.')}`;
};

const priceInt = (price) => replace(replace(price, '.', ''), '$', '');

const getLooseProductsQuantity = (data) => {
    const items = get(data, 'assignInfo.items', {});
    let parentProducts = 0;
    let childrenProducts = 0;
    forEach(items, ({ substitution, unpackaged, ...item }) => {
        if (unpackaged) parentProducts = parentProducts + getPickingQuantityByUni(item);
        if (size(substitution) > 0) {
            forEach(substitution, substitute => {
                if (get(substitute, 'unpackaged')) childrenProducts = childrenProducts + getPickingQuantityByUni(substitute);
            });
        }
    });
    return (parentProducts + childrenProducts);
};

export {
    formatProductQuantity,
    formatPrice,
    getLooseProductsQuantity,
    priceInt
};
